export const ALARM_TEMPLATE_LOAD = 'ALARM_TEMPLATE_LOAD';
export const ALARM_TEMPLATE_LOAD_SUCCESS = 'ALARM_TEMPLATE_LOAD_SUCCESS';
export const ALARM_TEMPLATE_LOAD_ERROR = 'ALARM_TEMPLATE_LOAD_ERROR';
export const ALARM_TEMPLATE_ADD = 'ALARM_TEMPLATE_ADD';
export const ALARM_TEMPLATE_ADD_SUCCESS = 'ALARM_TEMPLATE_ADD_SUCCESS';
export const ALARM_TEMPLATE_ADD_ERROR = 'ALARM_TEMPLATE_ADD_ERROR';
export const ALARM_TEMPLATE_UPDATE = 'ALARM_TEMPLATE_UPDATE';
export const ALARM_TEMPLATE_UPDATE_SUCCESS = 'ALARM_TEMPLATE_UPDATE_SUCCESS';
export const ALARM_TEMPLATE_UPDATE_ERROR = 'ALARM_TEMPLATE_UPDATE_ERROR';
export const ALARM_TEMPLATE_DELETE = 'ALARM_TEMPLATE_DELETE';
export const ALARM_TEMPLATE_DELETE_SUCCESS = 'ALARM_TEMPLATE_DELETE_SUCCESS';
export const ALARM_TEMPLATE_DELETE_ERROR = 'ALARM_TEMPLATE_DELETE_ERROR';
